import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
//import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PropTypes from "prop-types";
import fondo from "assets/img/riult.jpg";
import Snackbar from "components/Snackbar/Snackbar.js";


{/*function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}</Typography>
      );
}*/}
// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function SignInSide(props) {
  const [mensaje, setMensaje] = useState(null);
  const [bc, setBC] = useState(false);
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    
    const isLogin = await props.handleLogin( data.get("email"), data.get("password")); 
    if (!isLogin) {
      showNotification("bc",'datos incorrectos'); // Mostrar la notificación si el inicio de sesión falla
    }
  };

  const showNotification = (place, message) => {
    setMensaje(message);
    // Mostrar la notificación en el lugar especificado
    switch (place) {
      case "bc":
        showBottomCenterNotification(message);
        break;
      // Agrega más casos según sea necesario para otros lugares
      default:
        break;
    }
  };

  const showBottomCenterNotification = (message) => {
    // Mostrar la notificación en la parte inferior central
    console.log(message);
    setBC(true);
    setTimeout(() => {
      setBC(false);     
    }, 6000);
  };
  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Ajusta el nivel de transparencia aquí
              zIndex: 1,
            },
            backgroundImage: `url(${fondo})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light" ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          
          }}
        />
        <Grid 
        item
         xs={12}
          sm={8}
           md={5}
            component={Paper}
             elevation={6}
              square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              REGISTRO
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                Entrar
              </Button>
            {/*  <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </Link>
                </Grid>
              </Grid>
              <Copyright sx={{ mt: 5 }} />
          */}
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Snackbar
        place="tc"
        color="danger"
        message={mensaje}
        open={bc}
        closeNotification={() => setBC(false)}
        close
      />
    </ThemeProvider>
  );
}

SignInSide.propTypes = {
  handleLogin: PropTypes.func.isRequired,
};